import React, { useEffect } from 'react';
import { Marker, useMap } from 'react-leaflet';
import { getMarkerIcon } from '../../../utils';

const StaticMarker = ({ markerPosition, zoom, markerType }) => {
  const map = useMap();

  useEffect(() => {
    map.flyTo(markerPosition, zoom, { animate: false });
  });

  return (
    <Marker
      draggable={false}
      position={markerPosition}
      icon={getMarkerIcon(markerType)}
    />
  );
};

export default StaticMarker;
